import { LABEL_NAMES } from "./peopleBody.helper";

export const findById = (id, list) => {
  if (!list || !list.length || !id) {
    return null;
  }

  return list.find(x => x.id === id);
};

export const getContactNames = contactList => contactList.reduce((acc, cur, index) => {
  if (!cur || !cur.firstName || !cur.lastName) {
    return acc;
  }
  acc.push({
    name: `${cur.firstName} ${cur.lastName}`,
    id: cur.id
  });

  return acc;
}, []);
